import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import logoHSL from "../../assets/logo.png";
import { Box, Container, Typography } from "@material-ui/core";
import TmpButtonCustom from "../tempo/TmpButtonCustom/TmpButtonCustom";
import './NavigationBar.css';
import { useHistory } from "react-router-dom";

export default function NavigationBar() {

  const history = useHistory();

    const redirectListagem = () => {
        history.push("/buscarprotocolo");
    }

  return (
    <AppBar style={{ backgroundColor: '#fff', boxShadow: 'none', borderBottom: '1px solid #dcdcdc', marginBottom: "20px" }} position="static">
      <Toolbar style={{ height: '5.125rem'}}>
        <Container maxWidth="lg">
          <Box display="flex" justifyContent="space-between" alignItems="center" >
            <div className="logo-sirio">
              <img src={logoHSL} alt="Logo" style={{ height: "41px", width: "171px" }} />
              <div style={{ borderRight: '1px solid #dcdcdc', marginLeft: "10px", height: "41px" }}></div>
              <Typography style={{ color: '#000', marginLeft: "10px" }} variant="h6">
                Portal de Serviço de Apoio ao Médico
              </Typography>
            </div>
            <TmpButtonCustom type={'primary'} typeButton={'button'} size={'sm'} handleClick={() => { redirectListagem() }} >Acompanhar uma solicitação</TmpButtonCustom>
          </Box>
        </Container>
      </Toolbar>
    </AppBar>
  );
}
